import React, { useState, useEffect } from "react";
import {useSelector, useDispatch} from 'react-redux';
import { useSnackbar } from 'notistack';
import PropTypes from "prop-types";
import {TextField, Button, Grid, Typography} from "@material-ui/core/";
import api from "utils/API";
import apiform from "utils/APIForm";
import TableSummary from "./TableSummary";
import {
  MuiPickersUtilsProvider,
  DateTimePicker
} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from "moment-timezone";
import {
  getListRequestPatient,
} from 'actions/getListAction';
import "moment/locale/es";
import DetailSelect from "views/Widgets/FichaPaciente/detailSelect";
import ModalDialog from "views/Widgets/Common/ModalDialog";

moment.locale("es");

const ModalSummary = props => {
  const dispatch = useDispatch()
  const {
    openModal,
    closeModal,
    settypeRequest,
    setOpenDialogDelete,
    dataMedicalArray,
    dataResourceArray,
    state,
    dataPatient,
    storage=null,
  } = props;
  const [charge, setCharge] = useState(true);
  const [tempArray, setTempArray] = useState([]);
  const [requestDate, setrequestDate] = useState("");
  const [observation, setobservation] = useState("");
  const [documentGuide, setdocumentGuide] = useState(null);
  const [isEmergency, setisEmergency] = useState({value: false, label: "No"});
  const [sending, setsending] = useState(false);
  const [fileOrdenMedica, setfileOrdenMedica] = useState(null);
  const [fileFichaClinica, setfileFichaClinica] = useState(null);
  const [tipoTratamiento, settipoTratamiento] = useState(null);
  const [tiempoEstimadoTratamiento, settiempoEstimadoTratamiento] = useState("");
  const [requiereFormularioIsapre, setrequiereFormularioIsapre] = useState(false);
  const [insumosRequierenEvidencia, setinsumosRequierenEvidencia] = useState([]);
  const [fileFormularioIsapre, setfileFormularioIsapre] = useState(null);
  const [fileFichaDiasUso, setfileFichaDiasUso] = useState(null);
  const [fileEvidenciaDano, setfileEvidenciaDano] = useState(null);
  const limitObservation = 400
  const tieneMedicamentos = dataMedicalArray.length > 0;
  const idsItemsSolicitados = [...dataMedicalArray, ...dataResourceArray].map(row => row.id).filter(id => id);
  const requiereEvidenciaDano = insumosRequierenEvidencia.length > 0;
  // const [loading, setloading] = useState(state === "summary");

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const action = key => (
    <Button style={{background: "#af4c4c00", color: "#fff"}} onClick={() => {closeSnackbar(key)}}>
        CERRAR
    </Button>
  );

  const handleSnakeMessage = (message, variant, vertical= "top", hotizontal="center", persist=false) => {
    enqueueSnackbar(
        message,
        {
            variant,
            persist: persist,
            action,
            preventDuplicate: true,
            anchorOrigin: {
                vertical: vertical,
                horizontal: hotizontal,
            },
        }
    );
  };

  useEffect(() => {
    if (charge) {
      initialCharge();
    }
  });

  useEffect(() => {
    if (idsItemsSolicitados.length === 0) {
      setinsumosRequierenEvidencia([]);
      return;
    }
    api.get(`api/paciente/${dataPatient.id}/solicitudes/extras/requisitosdocumentos/?insumos=${idsItemsSolicitados.join(",")}`).then((response) => {
      setrequiereFormularioIsapre(response.data.requiere_formulario_isapre);
      setinsumosRequierenEvidencia(response.data.insumos_requieren_evidencia);
    }).catch(() => {});
  }, [idsItemsSolicitados.join(",")]);

  const initialCharge = () => {
    setCharge(false);

    let tempArrayRequest = [];
    let tempArrayMedicamentos = [];
    dataMedicalArray.map(data => {
      tempArrayRequest.push({
        tipo: "Medicamento",
        info: data
      });
      tempArrayMedicamentos.push({
        id_insumo_medicamento: data.id,
        cantidad: data.cantidad
      });
    });
    dataResourceArray.map(data => {
      tempArrayRequest.push({
        tipo: "Insumos",
        info: data
      });
    });


    setTempArray(tempArrayRequest);
  };

  const handleObservation = (value) => {
    setobservation(value);

  }

  const uploadDocumentoPaciente = (file, tipoDocumento) => {
    const formData = new FormData();
    formData.append("archivo", file[0]);
    formData.append("tipo_documento", tipoDocumento);
    formData.append("nombre_archivo", file[0].name);
    formData.append("id_paciente", dataPatient.id);
    return apiform.post("/api/documentospaciente/", formData).then((response) => response.data.id);
  }

  const saveRequest = status => {
    if (sending) {
      return;
    }
    setsending(true);

    const documentosRequeridos = [
      {file: fileOrdenMedica, tipoDocumento: "OrdenInsumosMedicamentos", clave: "idOrdenMedica"},
      {file: fileFichaClinica, tipoDocumento: "FichaClinica", clave: "idFichaClinica"},
    ];
    if (requiereFormularioIsapre) {
      documentosRequeridos.push({file: fileFormularioIsapre, tipoDocumento: "FormularioSolicitudExtraIsapre", clave: "idFormularioIsapre"});
    }
    if (requiereEvidenciaDano) {
      documentosRequeridos.push({file: fileFichaDiasUso, tipoDocumento: "FichaClinicaDiasUso", clave: "idFichaDiasUso"});
      documentosRequeridos.push({file: fileEvidenciaDano, tipoDocumento: "EvidenciaDano", clave: "idEvidenciaDano"});
    }

    Promise.all(documentosRequeridos.filter((doc) => doc.file).map((doc) => uploadDocumentoPaciente(doc.file, doc.tipoDocumento).then((id) => ({[doc.clave]: id})))).then((resultados) => {
      const idsDocumentos = resultados.reduce((accum, item) => ({...accum, ...item}), {});
      crearSolicitud(status, idsDocumentos);
    }).catch(() => {
      handleSnakeMessage("No se pudieron subir los documentos adjuntos. Revise su conexión e intente nuevamente.", "error");
      setsending(false);
    });
  };

  const crearSolicitud = (status, idsDocumentos) => {

    let productos_pedidos = {};
    let tempMedicamentos = [];
    dataMedicalArray.filter(data => data.id).map(data => {
      tempMedicamentos.push({
        id_insumo_medicamento: data.id,
        cantidad: data.cantidad
      });
    });

    let tempInsumos = [];
    dataResourceArray.filter(data => data.id).map(data => {
      tempInsumos.push({
        id_insumo_medicamento: data.id,
        cantidad: data.cantidad
      });
    });

    let tempEquipos = [];

    if (tempMedicamentos.length > 0) {
      productos_pedidos["medicamentos"] = tempMedicamentos;
    }
    if (tempInsumos.length > 0) {
      productos_pedidos["insumos"] = tempInsumos;
    }
    if (tempEquipos.length > 0) {
      productos_pedidos["equipos"] = [];
    }
    const body = {
      productos_pedidos: productos_pedidos,
      fecha_entrega: moment(requestDate).format("YYYY-MM-DDTHH:mm:ss"),
      observacion: observation,
      bodega: false,
      es_urgente: isEmergency.value,
      id_orden_insumos_medicamentos: idsDocumentos.idOrdenMedica,
      id_ficha_clinica: idsDocumentos.idFichaClinica,
    }
    if (idsDocumentos.idFormularioIsapre) {
      body["id_formulario_solicitud_extra_isapre"] = idsDocumentos.idFormularioIsapre
    }
    if (idsDocumentos.idFichaDiasUso) {
      body["id_ficha_clinica_dias_uso"] = idsDocumentos.idFichaDiasUso
    }
    if (idsDocumentos.idEvidenciaDano) {
      body["id_evidencia_dano"] = idsDocumentos.idEvidenciaDano
    }
    if (storage?.value){
      body["bodega_empresa"] = storage?.value
    }
    if (tieneMedicamentos) {
      body["tipo_tratamiento_medicamento"] = tipoTratamiento?.value
      if (tipoTratamiento?.value === "Agudo") {
        body["tiempo_estimado_tratamiento"] = parseInt(tiempoEstimadoTratamiento)
      }
    }

    api.post(`api/paciente/${dataPatient.id}/solicitudes/insumosextra/`, body).then(responsePost => {
        const finishRequest = () => {
          getListRequestPatient(dataPatient, dispatch)
          settypeRequest(null);
        }
        handleSnakeMessage("Solicitud generada con éxito", "success");
        if (status && documentGuide) {
          const formData = new FormData();
          formData.append("nombre_archivo", documentGuide[0].name);
          formData.append("archivo", documentGuide[0]);
          formData.append("tipo_documento", "Receta");
          formData.append("observacion", "");
          formData.append("area", "Clinica");
          formData.append("id_paciente", dataPatient.id);
          formData.append("id_solicitud_paciente", responsePost.data.solicitud.id);
          apiform.post("/api/documentospaciente/", formData).then(() => {
            finishRequest();
          }).catch(() => {
            handleSnakeMessage("La solicitud fue creada, pero la receta no pudo adjuntarse. Puede subirla luego desde los documentos del paciente.", "warning");
            finishRequest();
          })
        } else {
          finishRequest();
        }
      }).catch(error => {
        handleSnakeMessage("No se pudo generar la solicitud. Revise su conexión e intente nuevamente.", "error");
        setsending(false);
      })

  };

  const _content_ = <div>
    <Grid container justify="center">
      <Grid item container xs={12} justify="center">
        <TableSummary tempArray={tempArray} />
      </Grid>
      {state === "summary" &&
      <Grid
        item
        xs={12}
        container
        direction="row"
        justify="center"
        alignItems="center"

      >
        <Grid
          item
          xs={12}
          container
          direction="row"
          justify="center"
          alignItems="center"
          style={{padding: "5px 0"}}
        >
          <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
            <DateTimePicker
                variant="inline"
                format="DD/MM/YYYY HH:mm"
                margin="normal"
                label={"Fecha entrega en domiciolio"}
                placeholder=""
                minDate={moment()}
                minDateMessage={"La fecha de envío no puede ser anterior al día de hoy"}
                cancelLabel={"Cancelar"}
                okLabel={"Aceptar"}
                onChange={(value) => setrequestDate(value)}
                value={requestDate}
                inputVariant={"outlined"}
                invalidDateMessage={"Debe ingresar fecha de entrega en domicilio"}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid
              item
              xs={4}
              container
              direction="row"
              justify="center"
              alignItems="center"
              style={{padding: "5px 0"}}
            >
            <DetailSelect
              value={isEmergency}
              onchange={value => {setisEmergency(value)}}
              label={"Es urgente?"}
              list={[{value: false, label: "No"}, {value: true, label: "Sí"}]}
            />
        </Grid>
        <Grid
          container
          direction="column"
          justify="center"
          alignItems="flex-end"
          item
          xs={12}
        >
          <Grid item xs={12} style={{padding: "5px", width: "100%"}}>
            <TextField
              label={"Observaciones"}
              multiline
              rows={8}
              value={observation}
              variant="outlined"
              onChange={(event) => handleObservation(event.target.value)}
              style={{width: "100%"}}
            />
          </Grid>
          <Typography style={{margin: "0 5px 0 0"}} variant="body2" gutterBottom>
            {`${observation?.length || 0 }/${limitObservation}`}
          </Typography>
        </Grid>
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="flex-contain"
          item
          xs={8}
          style={{ margin: "10px 0" }}
        >
          <Button
            variant="contained"
            component="label"
            color="primary"
            className="text-white"
            style={{ margin: "0 10px" }}
          >
            Subir Archivo
            <TextField
              type="file"
              id="documentGuide"
              onChange={(event) => setdocumentGuide(event.target.files)}
              fullWidth
              my={2}
              style={{ display: "none" }}
            />
          </Button>
          {(documentGuide && documentGuide.length > 0) && `${documentGuide[0].name}`}
        </Grid>
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="center"
          item
          xs={12}
          style={{ margin: "10px 0" }}
        >
          <Button
            variant="contained"
            component="label"
            color="primary"
            className="text-white"
            style={{ margin: "0 10px 0 0" }}
          >
            Adjuntar orden médica
            <TextField
              type="file"
              id="orden-medica-insumos-medicamentos"
              onChange={(event) => setfileOrdenMedica(event.target.files)}
              fullWidth
              my={2}
              style={{ display: "none" }}
              accept={("pdf", "jpg", "jpeg", "png")}
            />
          </Button>
          <Typography variant="body2">
            {fileOrdenMedica === null ? "Orden médica (opcional)" : fileOrdenMedica[0]?.name}
          </Typography>
        </Grid>
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="center"
          item
          xs={12}
          style={{ margin: "10px 0" }}
        >
          <Button
            variant="contained"
            component="label"
            color="primary"
            className="text-white"
            style={{ margin: "0 10px 0 0" }}
          >
            Adjuntar ficha clínica
            <TextField
              type="file"
              id="ficha-clinica-insumos-medicamentos"
              onChange={(event) => setfileFichaClinica(event.target.files)}
              fullWidth
              my={2}
              style={{ display: "none" }}
              accept={("pdf", "jpg", "jpeg", "png")}
            />
          </Button>
          <Typography variant="body2">
            {fileFichaClinica === null ? "Ficha clínica (opcional)" : fileFichaClinica[0]?.name}
          </Typography>
        </Grid>
        {tieneMedicamentos &&
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="center"
          item
          xs={12}
          style={{ margin: "10px 0" }}
        >
          <Grid item xs={4}>
            <DetailSelect
              value={tipoTratamiento}
              onchange={(value) => settipoTratamiento(value)}
              label={"Tipo de tratamiento (medicamentos)"}
              list={[{value: "Agudo", label: "Agudo"}, {value: "Permanente", label: "Permanente"}]}
            />
          </Grid>
          {tipoTratamiento?.value === "Agudo" &&
          <Grid item xs={4} style={{padding: "0 10px"}}>
            <TextField
              label={"Tiempo estimado (días)"}
              type="number"
              inputProps={{min: 1, step: 1}}
              value={tiempoEstimadoTratamiento}
              variant="outlined"
              onChange={(event) => settiempoEstimadoTratamiento(event.target.value.replace(/[^0-9]/g, ""))}
              fullWidth
            />
          </Grid>
          }
        </Grid>
        }
        {requiereFormularioIsapre &&
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="center"
          item
          xs={12}
          style={{ margin: "10px 0" }}
        >
          <Button
            variant="contained"
            component="label"
            color="primary"
            className="text-white"
            style={{ margin: "0 10px 0 0" }}
          >
            Adjuntar formulario de solicitudes extras (Isapre)
            <TextField
              type="file"
              id="formulario-isapre-insumos-medicamentos"
              onChange={(event) => setfileFormularioIsapre(event.target.files)}
              fullWidth
              my={2}
              style={{ display: "none" }}
              accept={("pdf", "jpg", "jpeg", "png")}
            />
          </Button>
          <Typography variant="body2">
            {fileFormularioIsapre === null ? "Recomendado para esta isapre (opcional)" : fileFormularioIsapre[0]?.name}
          </Typography>
        </Grid>
        }
        {requiereEvidenciaDano &&
        <>
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="center"
          item
          xs={12}
          style={{ margin: "10px 0" }}
        >
          <Button
            variant="contained"
            component="label"
            color="primary"
            className="text-white"
            style={{ margin: "0 10px 0 0" }}
          >
            Adjuntar ficha clínica con días de uso
            <TextField
              type="file"
              id="ficha-dias-uso-insumos-medicamentos"
              onChange={(event) => setfileFichaDiasUso(event.target.files)}
              fullWidth
              my={2}
              style={{ display: "none" }}
              accept={("pdf", "jpg", "jpeg", "png")}
            />
          </Button>
          <Typography variant="body2">
            {fileFichaDiasUso === null ? "Recomendada para este insumo (opcional)" : fileFichaDiasUso[0]?.name}
          </Typography>
        </Grid>
        <Grid
          container
          direction="row"
          justify="flex-start"
          alignItems="center"
          item
          xs={12}
          style={{ margin: "10px 0" }}
        >
          <Button
            variant="contained"
            component="label"
            color="primary"
            className="text-white"
            style={{ margin: "0 10px 0 0" }}
          >
            Adjuntar evidencia del daño
            <TextField
              type="file"
              id="evidencia-dano-insumos-medicamentos"
              onChange={(event) => setfileEvidenciaDano(event.target.files)}
              fullWidth
              my={2}
              style={{ display: "none" }}
              accept={("pdf", "jpg", "jpeg", "png")}
            />
          </Button>
          <Typography variant="body2">
            {fileEvidenciaDano === null ? "Recomendada para este insumo (opcional)" : fileEvidenciaDano[0]?.name}
          </Typography>
        </Grid>
        </>
        }
      </Grid>
      }
    </Grid>
</div>

  const _actions_ = <>
    {state === "summary" ? <>
     <Button
        variant="contained"
        color="primary"
        onClick={closeModal}
        style={{ textTransform: "none" }}
      >
        Atrás
      </Button>
      {(((observation?.length || 0) <= limitObservation) && observation?.trim() !== "" && requestDate !== ""
        && (!tieneMedicamentos || (tipoTratamiento?.value && (tipoTratamiento.value !== "Agudo" || parseInt(tiempoEstimadoTratamiento) > 0)))
      ) ?
        <Button
        disabled={sending}
        variant="contained"
        style={{
          backgroundColor: sending ? "#dddddd" : "#43a047",
          textTransform: "none",
          color: "#fff"
        }}
        onClick={() => {
          saveRequest(true);
        }}
      >
        {sending ? "Enviando..." : "Enviar"}
      </Button>:
      <Button
        disabled
        variant="contained"
        style={{
          textTransform: "none",
        }}
      >
        Enviar
      </Button>
      }

      </> : <>
        <Button
          variant="contained"
          style={{
            backgroundColor: "#43a047",
            textTransform: "none",
            color: "#fff"
          }}
          onClick={() => {
            settypeRequest(null);
            closeModal();
          }}
        >
        Agregar Items
      </Button>
      <Button
        variant="contained"
        color="secondary"
        style={{
          textTransform: "none"
        }}
        onClick={() => {
          setOpenDialogDelete(true);
        }}
      >
        Eliminar solicitud
      </Button>
      </>}
  </>

  return (
    <ModalDialog
      open={openModal}
      onClose={closeModal}
      title={`Resumen solicitud`}
      _content_={_content_}
      _actions_ = {_actions_}
    />
  );
};

export default ModalSummary;

ModalSummary.propTypes = {
  openModal: PropTypes.bool,
  closeModal: PropTypes.func,
  tempDateInfo: PropTypes.object,
  idFicha: PropTypes.string,
  setOpenDialogSucess: PropTypes.func,
  setOpenModalAddRecord: PropTypes.func,
  setTempMessage: PropTypes.func,
  variableCounter: PropTypes.object,
  setVariableCounter: PropTypes.func,
  setPageRefresh: PropTypes.func,
  eventsVariables: PropTypes.array,
  setEvents: PropTypes.func,
  extraShift: PropTypes.bool,
  extraAttention: PropTypes.bool,
  holiday: PropTypes.bool,
  unpaidLeave: PropTypes.bool,
  absence: PropTypes.bool,
  settypeRequest: PropTypes.func,
  setOpenDialogDelete: PropTypes.func,
  dataMedicalArray: PropTypes.array,
  dataResourceArray: PropTypes.array,
  state: PropTypes.string,
  dataPatient: PropTypes.object,
};
